import styled, { createGlobalStyle } from 'styled-components';
const sizeMaxWidth = {
  auto: 'modalSizeAuto',
  small: 'modalSizeSmall',
  medium: 'modalSizeMedium',
  large: 'modalSizeLarge',
  full: 'modalSizeFull'
};
export const GlobalModalStyle = createGlobalStyle`
  .ReactModal__Body--open {
    overflow: hidden;
  }
`;
export const getContentStyle = ({
  shadow,
  padding,
  borderRadius,
  size,
  maxHeight,
  maxWidth,
  overflow,
  theme,
  isWiderThanXs,
  useBottomSheetOnMobile
}) => {
  const borderRadiusValue = borderRadius || theme.modalBorderRadius;
  return {
    position: 'relative',
    margin: 0,
    padding: padding || theme.modalPadding,
    top: null,
    left: null,
    bottom: null,
    right: null,
    maxHeight: maxHeight || '100%',
    maxWidth: maxWidth || theme[sizeMaxWidth[size]],
    borderRadius: borderRadiusValue,
    backgroundColor: theme.palette.backgroundPrimary,
    border: theme.modalBorder,
    boxShadow: shadow || theme.boxShadowHighest,
    width: size === 'auto' ? 'auto' : '100%',
    overflow: overflow || 'auto',
    ...(useBottomSheetOnMobile && !isWiderThanXs ? {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0
    } : {
      borderBottomLeftRadius: borderRadiusValue,
      borderBottomRightRadius: borderRadiusValue
    })
  };
};
export const getOverlayStyle = ({
  zIndex,
  theme,
  isWiderThanXs,
  useBottomSheetOnMobile
}) => ({
  backgroundColor: theme.palette.backgroundOverlay,
  display: 'flex',
  justifyContent: 'center',
  alignItems: useBottomSheetOnMobile && !isWiderThanXs ? 'end' : 'center',
  overflow: 'auto',
  paddingTop: theme.spacing.xl,
  paddingBottom: useBottomSheetOnMobile && !isWiderThanXs ? 0 : theme.spacing.xl,
  zIndex: zIndex || theme.zIndex.modal
});
export const CloseIcon = styled.div`
  text-align: right;
  height: ${({
  $closeIconSmallRegion
}) => $closeIconSmallRegion ? '0.5rem' : 'auto'};
  margin-bottom: ${({
  theme,
  $closeIconSmallRegion
}) => $closeIconSmallRegion ? 0 : theme.spacing.xs};
`;
//# sourceMappingURL=styles.js.map